import { Link, useLocation } from 'react-router-dom';
import { FolderOpen, Settings } from 'lucide-react';
import ThemeToggle from '../ui/ThemeToggle';

const navigation = [
  { name: 'Projects', href: '/dashboard', icon: FolderOpen },
  { name: 'Settings', href: '/settings', icon: Settings },
];

export default function Sidebar() {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || (path === '/dashboard' && location.pathname.startsWith('/projects'));
  };

  return (
    <aside className="w-52 bg-slate-900 dark:bg-dark-sidebar border-r border-slate-700 dark:border-dark-border min-h-screen sticky top-0 hidden md:flex flex-col">
      <nav className="flex flex-col h-full">
        {/* Logo */}
        <div className="p-6 border-b border-slate-700 dark:border-dark-border">
          <Link to="/dashboard">
            <h1 className="text-2xl font-bold font-rajdhani text-white">
              SureDox
            </h1>
          </Link>
        </div>

        {/* Primary Navigation */}
        <div className="flex-1 p-4 space-y-1">
          {navigation.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.href);

            return (
              <Link
                key={item.name}
                to={item.href}
                className={`
                  flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition
                  ${active
                    ? 'bg-slate-800 text-white border-l-4 border-emerald-500'
                    : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                  }
                `}
              >
                <Icon className="w-5 h-5" />
                {item.name}
              </Link>
            );
          })}
        </div>

        {/* Theme Toggle */}
        <div className="p-4 border-t border-slate-700 dark:border-dark-border">
          <ThemeToggle />
        </div>
      </nav>
    </aside>
  );
}
